/**
 * Profile Dropdown 클래스
 * 헤더의 프로필 드롭다운 메뉴를 관리합니다.
 */
export class ProfileDropdown {
    constructor(buttonId, dropdownId) {
        this.button = document.getElementById(buttonId);
        this.dropdown = document.getElementById(dropdownId);
        this.isOpen = false;

        if (!this.button || !this.dropdown) {
            return;
        }

        this.init();
    }

    init() {
        // 버튼 클릭 이벤트
        this.button.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggle();
        });

        // 외부 클릭 시 닫기
        this.handleOutsideClick = (e) => {
            if (!this.button.contains(e.target) && !this.dropdown.contains(e.target)) {
                this.close();
            }
        };
        document.addEventListener('click', this.handleOutsideClick);

        // ESC 키로 닫기
        this.handleEscape = (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        };
        document.addEventListener('keydown', this.handleEscape);

        // 드롭다운 내부 링크 클릭 시 닫기
        const links = this.dropdown.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', () => {
                // 로그아웃 링크는 즉시 닫지 않음 (페이지 이동 전)
                if (!link.classList.contains('no-header__profile-dropdown-item--danger') && 
                    !link.classList.contains('no-drawer__profile-dropdown-item--danger')) {
                    this.close();
                }
            });
        });
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        // header와 drawer 모두 지원
        this.dropdown.classList.add('no-header__profile-dropdown--open');
        this.dropdown.classList.add('no-drawer__profile-dropdown--open');
        this.dropdown.setAttribute('aria-expanded', 'true');
        this.button.setAttribute('aria-expanded', 'true');
    }

    close() {
        this.isOpen = false;
        // header와 drawer 모두 지원
        this.dropdown.classList.remove('no-header__profile-dropdown--open');
        this.dropdown.classList.remove('no-drawer__profile-dropdown--open');
        this.dropdown.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-expanded', 'false');
    }

    destroy() {
        if (this.handleOutsideClick) {
            document.removeEventListener('click', this.handleOutsideClick);
        }
        if (this.handleEscape) {
            document.removeEventListener('keydown', this.handleEscape);
        }
    }
}

